<template>
  <div>
    <!-- <Navgar></Navgar> -->
    <div class="home">
      <div class="content">
        <h1>有职Offer</h1>
        <p>助您走稳职场的第一步</p>
      </div>
    </div>
  </div>
</template>
<script>
import Navgar from "../components/Navgar/Navgar.vue";
export default {
  name: "Home",
  components: {
    Navgar,
  },
  methods: {
    goServices() {
      console.log("华东")
      window.scrollTo({
        top: 1000,
        left: 0,
        behavior: "smooth",
      });
      // this.$router.push("/services");
    },
  },
};
</script>

<style scoped>
.home {
  background: url("../assets/youzhi_background.png") no-repeat center center;
  background-size: cover;
  height: 85vh;
  position: relative;
  color: #333;
  text-align: left;
  padding-left: 10vw;
  padding-top: 15vh;
  /* margin-top: 15vh; */
}

.content {
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 20vh;
}

.home h1 {
  font-size: 50px;
  margin: 0;
}

.home p {
  font-size: 30px;
  margin: 0;
}

.arrow-container {
  position: absolute;
  bottom: 20px;
  /* Adjust as needed */
  left: 50%;
  transform: translateX(-50%);
}

.arrow-container img {
  width: 30px;
  height: auto;
}
</style>
